// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * kUML Portal -- brand design tokens.
 * Mirrors dev.kuml.renderer.theme.core.KumlBrandTheme 1:1, so chrome UI and rendered SVGs share one
 * visual family. See the approved design spec (Runde 3) for the full rationale table.
 */
:root {
    --kportal-bg: #FFFFFF;
    --kportal-surface: #F8F5F0;
    --kportal-ink: #0D1525;
    --kportal-muted: #6B7A99;
    --kportal-navy: #1D2B4F;
    --kportal-navy-hairline: rgba(29, 43, 79, 0.14);
    --kportal-navy-hairline-strong: rgba(29, 43, 79, 0.28);
    --kportal-gold: #C49A2E;
    --kportal-danger: #B0432E;
    --kportal-shadow: 0 2px 8px rgba(13, 21, 37, 0.10);
    --kportal-radius: 8px;
    --kportal-font: Geist, Inter, system-ui, sans-serif;
}

@media (prefers-color-scheme: dark) {
    :root {
        --kportal-bg: #141B2B;
        --kportal-surface: #1B2438;
        --kportal-ink: #F4F1EA;
        --kportal-muted: #9AA9C7;
        --kportal-navy-hairline: rgba(196, 154, 46, 0.18);
        --kportal-navy-hairline-strong: rgba(196, 154, 46, 0.32);
    }
}

* {
    box-sizing: border-box;
}

html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    background: var(--kportal-bg);
    color: var(--kportal-ink);
    font-family: var(--kportal-font);
    font-size: 15px;
    line-height: 1.5;
    font-weight: 400;
}

#kportal {
    min-height: 100vh;
}

h1, h2, h3 {
    font-weight: 600;
    margin: 0;
}

button, input, textarea {
    font-family: inherit;
}

a {
    color: inherit;
}

/* ---------- Layout shells ---------- */

.kportal-auth-shell {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    background: var(--kportal-bg);
    padding: 16px;
}

.kportal-auth-card {
    width: 100%;
    max-width: 400px;
    background: var(--kportal-surface);
    border: 1px solid var(--kportal-navy-hairline);
    border-radius: var(--kportal-radius);
    padding: 32px;
}

.kportal-wordmark {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
}

/*
 * Logo (replaces the old text wordmark, kUML's own "{k}kUML" mark -- same two SVGs kuml.dev's own
 * header already switches between for light/dark). Both variants are always in the DOM; only one
 * is ever visible, toggled purely by CSS \`prefers-color-scheme\` (no JS listener needed -- the
 * marketing site needs one only because it also has a manual theme toggle button, which the
 * Portal doesn't).
 */
.kportal-logo-light, .kportal-logo-dark {
    height: 28px;
    display: block;
}

.kportal-logo-dark {
    display: none;
}

@media (prefers-color-scheme: dark) {
    .kportal-logo-light {
        display: none;
    }

    .kportal-logo-dark {
        display: block;
    }
}

.kportal-page {
    max-width: 1120px;
    margin: 0 auto;
    padding: 0 24px 48px;
}

.kportal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--kportal-navy-hairline);
    background: var(--kportal-bg);
    padding: 16px 24px;
}

.kportal-header-left {
    display: flex;
    align-items: center;
    gap: 16px;
}

.kportal-header-logo {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.kportal-header-right {
    display: flex;
    align-items: center;
    gap: 12px;
}

/* ---------- Legal links (Impressum / Datenschutz) ---------- */

.kportal-legal-links {
    display: flex;
    align-items: center;
    gap: 8px;
}

.kportal-legal-link {
    font-size: 13px !important;
    font-weight: 400 !important;
    cursor: pointer;
    border: none !important;
    background: none !important;
    color: var(--kportal-muted) !important;
    padding: 0 !important;
    text-decoration: underline;
    text-decoration-color: transparent;
}

.kportal-legal-link:hover {
    text-decoration-color: var(--kportal-muted);
}

.kportal-legal-sep {
    font-size: 13px;
    color: var(--kportal-muted);
}

/* ---------- R-18: language switcher ---------- */

.kportal-lang-switch {
    display: flex;
    align-items: center;
    gap: 4px;
}

.kportal-lang-option {
    font-size: 12px !important;
    font-weight: 400 !important;
    letter-spacing: 0.04em;
    cursor: pointer;
    border: none !important;
    background: none !important;
    color: var(--kportal-muted) !important;
    padding: 0 !important;
    border-bottom: 2px solid transparent;
}

.kportal-lang-option-active {
    font-weight: 600 !important;
    color: var(--kportal-ink) !important;
    border-bottom: 2px solid var(--kportal-gold);
}

.kportal-lang-sep {
    font-size: 12px;
    color: var(--kportal-muted);
}

/* ---------- R-18: auth screen footer (legal links + language switcher) ---------- */

.kportal-auth-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-top: 12px;
}

/* ---------- Email infrastructure wave: forgot-password mini form (AuthScreen) and the
   verify-email/reset-password landing screens -- all share the .kportal-auth-card shell. ---------- */

.kportal-auth-title {
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
}

.kportal-auth-message {
    text-align: center;
    color: var(--kportal-muted);
    font-size: 14px;
    margin-bottom: 20px;
}

.kportal-auth-actions {
    display: flex;
    justify-content: center;
}

.kportal-auth-forgot-link {
    display: flex;
    justify-content: flex-end;
    margin: -8px 0 16px;
}

.kportal-auth-back-link {
    display: flex;
    justify-content: center;
    margin-top: 12px;
}

/* ---------- R-3: "please verify your email" banner (project list) ---------- */

.kportal-verify-banner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    background: var(--kportal-surface);
    border: 1px solid var(--kportal-gold);
    border-radius: var(--kportal-radius);
    padding: 12px 16px;
    margin: 24px 0 0;
    flex-wrap: wrap;
}

.kportal-verify-banner-text {
    font-size: 14px;
    font-weight: 500;
}

.kportal-verify-banner-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

/* ---------- R-18: legal page header (back link + language switcher) ---------- */

.kportal-legal-page-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
}

.kportal-legal-page-head .kportal-legal-back {
    margin-bottom: 0;
}

.kportal-legal-notice {
    font-size: 13px;
    color: var(--kportal-muted);
    background: var(--kportal-surface);
    border: 1px solid var(--kportal-navy-hairline);
    border-radius: var(--kportal-radius);
    padding: 10px 14px;
    margin-bottom: 24px;
}

/*
 * !important below: KVision's Button/TextInput/TextArea widgets always add Bootstrap's own
 * "btn"/"btn-primary"/"form-control" classes (see io.kvision.html.Button.buildClassSet /
 * io.kvision.form.text.TextInput), which normally load (via kvision-bootstrap's BootstrapModule,
 * initialized during startApplication before PortalApp is constructed) before this app.css module
 * does. A same-specificity single-class selector loaded later in the cascade would already win
 * without !important, but pinning it explicitly here removes any dependency on that load-order
 * detail surviving future webpack/module-init changes.
 */
.kportal-header-wordmark {
    font-size: 20px !important;
    font-weight: 600 !important;
    cursor: pointer;
    border: none !important;
    background: none !important;
    color: var(--kportal-ink) !important;
    padding: 0 !important;
}

/* ---------- Tabs (Auth) ---------- */

.kportal-tabs {
    display: flex;
    gap: 24px;
    justify-content: center;
    margin-bottom: 24px;
}

.kportal-tab {
    background: none;
    border: none;
    padding: 4px 2px 8px;
    font-size: 15px;
    font-weight: 500;
    color: var(--kportal-muted);
    cursor: pointer;
    border-bottom: 2px solid transparent;
}

.kportal-tab.active {
    color: var(--kportal-ink);
    border-bottom-color: var(--kportal-gold);
}

/* ---------- Form fields ---------- */

.kportal-field {
    margin-bottom: 16px;
}

.kportal-label {
    display: block;
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 4px;
}

.kportal-input, .kportal-textarea {
    width: 100% !important;
    background: var(--kportal-bg) !important;
    border: 1px solid var(--kportal-navy-hairline-strong) !important;
    border-radius: var(--kportal-radius) !important;
    padding: 8px 12px !important;
    font-size: 15px !important;
    color: var(--kportal-ink) !important;
    box-shadow: none !important;
}

.kportal-textarea {
    background: var(--kportal-surface) !important;
    min-height: 6em;
    resize: vertical;
}

.kportal-input::placeholder, .kportal-textarea::placeholder {
    color: var(--kportal-muted);
}

.kportal-input.kportal-input-error, .kportal-textarea.kportal-input-error {
    border-color: var(--kportal-danger);
}

.kportal-field-error {
    color: var(--kportal-danger);
    font-size: 13px;
    margin-top: 4px;
}

.kportal-input:focus, .kportal-textarea:focus, button:focus-visible, .kportal-tab:focus-visible,
.kportal-chip:focus-visible, .kportal-icon-button:focus-visible {
    outline: 2px solid var(--kportal-navy);
    outline-offset: 2px;
}

/* ---------- Buttons ---------- */

.kportal-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 500;
    border-radius: var(--kportal-radius);
    padding: 8px 16px;
    cursor: pointer;
    border: 1px solid transparent;
}

.kportal-btn:disabled {
    cursor: not-allowed;
    opacity: 0.55;
}

.kportal-btn-primary {
    background: var(--kportal-navy) !important;
    color: #FFFFFF !important;
    border-color: var(--kportal-navy) !important;
    width: 100%;
}

.kportal-btn-primary.kportal-btn-auto {
    width: auto;
}

.kportal-btn-secondary {
    background: transparent !important;
    border-color: var(--kportal-navy-hairline-strong) !important;
    color: var(--kportal-ink) !important;
}

.kportal-btn-text {
    background: none !important;
    border: none !important;
    color: var(--kportal-danger) !important;
    font-weight: 500;
    cursor: pointer;
    padding: 4px 8px;
}

/* Same plain-text button shape as .kportal-btn-text, but for non-destructive actions (e.g.
   cancelling an in-flight generation) -- the danger-red color is reserved for actually-destructive
   confirmations (delete), so this variant uses the neutral/muted ink instead. */
.kportal-btn-text-neutral {
    background: none !important;
    border: none !important;
    color: var(--kportal-muted) !important;
    font-weight: 500;
    cursor: pointer;
    padding: 4px 8px;
}

.kportal-chip {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: var(--kportal-bg);
    border: 1px solid var(--kportal-navy-hairline-strong);
    border-radius: var(--kportal-radius);
    padding: 8px 12px;
    font-size: 15px;
    color: var(--kportal-ink);
    cursor: pointer;
}

.kportal-icon-button {
    background: none;
    border: none;
    color: var(--kportal-ink);
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
}

/* ---------- Usage chip ---------- */

.kportal-usage-chip {
    background: var(--kportal-surface);
    border: 1px solid var(--kportal-navy-hairline);
    border-radius: var(--kportal-radius);
    padding: 6px 12px;
    font-size: 13px;
    color: var(--kportal-muted);
    cursor: default;
}

.kportal-usage-chip.kportal-usage-chip-limit {
    color: var(--kportal-gold);
}

/* ---------- Project list ---------- */

.kportal-section-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 32px 0 24px;
}

.kportal-page-title {
    font-size: 28px;
    font-weight: 600;
}

.kportal-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
}

@media (max-width: 900px) {
    .kportal-grid { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 600px) {
    .kportal-grid { grid-template-columns: 1fr; }
}

.kportal-card {
    background: var(--kportal-surface);
    border: 1px solid var(--kportal-navy-hairline);
    border-radius: var(--kportal-radius);
    padding: 24px;
    cursor: pointer;
    position: relative;
}

.kportal-card-name {
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 4px;
}

.kportal-card-meta {
    font-size: 13px;
    color: var(--kportal-muted);
    margin-bottom: 16px;
}

.kportal-card-actions {
    display: flex;
    gap: 16px;
}

.kportal-empty-state {
    text-align: center;
    padding: 64px 24px;
    color: var(--kportal-muted);
}

.kportal-skeleton-card {
    background: var(--kportal-surface);
    border: 1px solid var(--kportal-navy-hairline);
    border-radius: var(--kportal-radius);
    height: 112px;
    opacity: 0.6;
}

.kportal-popover {
    position: absolute;
    z-index: 10;
    top: 100%;
    right: 0;
    margin-top: 8px;
    background: var(--kportal-bg);
    border: 1px solid var(--kportal-navy-hairline);
    border-radius: var(--kportal-radius);
    box-shadow: var(--kportal-shadow);
    padding: 16px;
    width: 260px;
    font-size: 13px;
}

.kportal-popover-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 12px;
}

/* ---------- Editor ---------- */

.kportal-editor-subheader {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 24px 0;
}

.kportal-back-link {
    background: none;
    border: none;
    color: var(--kportal-ink);
    cursor: pointer;
    font-size: 20px;
    padding: 4px;
    display: inline-flex;
    align-items: center;
}

.kportal-project-name {
    font-size: 20px;
    font-weight: 600;
    cursor: text;
    border-bottom: 1px dashed transparent;
}

.kportal-project-name:hover {
    border-bottom-color: var(--kportal-navy-hairline-strong);
}

/* Live-collaboration presence indicator (e.g. "1 andere Verbindung aktiv") -- same muted, small
   family as .kportal-status-detail; empty content (no other connections) renders nothing. */
.kportal-collab-indicator {
    font-size: 13px;
    color: var(--kportal-muted);
    margin-left: auto;
}

/* Soft fade-in for the sub-header name after a silent auto-rename (mustFix 3), so the user notices
   the self-naming without it feeling abrupt. */
.kportal-fade-in {
    animation: kportal-fade-in 0.6s ease;
}

@keyframes kportal-fade-in {
    from { opacity: 0.25; }
    to { opacity: 1; }
}

/* R-22: diagram-tab bar, one row below the project-name subheader -- see DiagramTabs.kt's KDoc. */
.kportal-diagram-tabs {
    display: flex;
    align-items: center;
    gap: 4px;
    overflow-x: auto;
    margin: 0 0 16px;
    border-bottom: 1px solid var(--kportal-navy-hairline);
}

.kportal-diagram-tab {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 8px 12px;
    font-size: 13px;
    color: var(--kportal-muted);
    border-bottom: 2px solid transparent;
    white-space: nowrap;
    position: relative;
}

.kportal-diagram-tab-active {
    color: var(--kportal-ink);
    border-bottom-color: var(--kportal-gold);
    font-weight: 600;
}

.kportal-diagram-tab-name {
    cursor: pointer;
}

.kportal-diagram-tab-active .kportal-diagram-tab-name {
    cursor: default;
}

.kportal-diagram-tab-action {
    font-size: 12px;
    opacity: 0.7;
}

.kportal-diagram-tab-action:hover {
    opacity: 1;
}

.kportal-diagram-tab-input {
    font-size: 13px;
    padding: 2px 4px;
    width: 140px;
}

.kportal-diagram-tab-add {
    background: none;
    border: none;
    color: var(--kportal-muted);
    cursor: pointer;
    font-size: 16px;
    padding: 6px 12px;
}

.kportal-diagram-tab-add:hover {
    color: var(--kportal-ink);
}

.kportal-editor-grid {
    display: grid;
    grid-template-columns: 65% 1fr;
    gap: 24px;
    align-items: start;
}

@media (max-width: 860px) {
    .kportal-editor-grid {
        grid-template-columns: 1fr;
    }
}

.kportal-stage {
    background: var(--kportal-surface);
    border: 1px solid var(--kportal-navy-hairline);
    border-radius: var(--kportal-radius);
    min-height: 420px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    position: relative;
    overflow: hidden;
    cursor: default;
}

/* R-6 zoom/pan: once zoomed past fit, dragging pans the diagram -- cursor hints follow the same
   convention as obsidian-kuml's KumlZoomModal (grab when pannable, grabbing while actively
   dragging). Toggled from EditorScreen.kt's applyZoomTransform()/handlePointerDown(). */
.kportal-stage.kportal-zoom-pannable {
    cursor: grab;
}

.kportal-stage.kportal-zoom-panning {
    cursor: grabbing;
}

/* Transform target for zoom/pan (EditorScreen.kt's \`zoomWrapper\`) -- absolutely positioned so its
   untransformed top-left coincides with .kportal-stage's own box regardless of that box's padding
   or this element's (unscaled) content size, which the zoom/pan pivot math in ZoomMath.kt assumes.
   \`transform-origin: 0 0\` keeps scale anchored at that same top-left corner. */
.kportal-zoom-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform-origin: 0 0;
    will-change: transform;
}

/* Sized at its natural pixel size (from the generated SVG's width/height) -- all zoom/pan scaling
   happens via .kportal-zoom-wrapper's transform (computed in EditorScreen.kt), not CSS shrink-to-
   fit, so no max-width/max-height here (unlike the old unconditional ".kportal-stage img" rule,
   which is now effectively scoped away from the real diagram image by that image always being
   nested inside .kportal-zoom-wrapper rather than a direct child of .kportal-stage). */
.kportal-zoom-wrapper img {
    display: block;
    transition: opacity 0.25s ease;
}

/* R-27: dims the whole zoom wrapper (an \`<img>\` OR an inlined, interactive \`<svg>\` -- see
   EditorScreen.kt's \`setDimmed\`'s KDoc), not \`<img>\` specifically -- \`.kportal-zoom-wrapper\` is
   the element \`setDimmed\` actually toggles this class on since this wave. */
.kportal-zoom-wrapper.kportal-stage-dimmed {
    opacity: 0.45;
}

/* R-27: click-to-select highlight on an inlined SVG's node/edge elements (see DiagramCanvas.kt's
   \`applyHighlight\`). \`!important\` on stroke: the renderer's own \`.kuml-*\` classes already set a
   stroke color/width inline via CSS class, and this highlight must always win regardless of
   which element kind (class/interface/enumeration box, association/generalization/... line) it
   lands on. */
.kportal-zoom-wrapper [data-kuml-id].kportal-canvas-selected {
    outline: 2px solid var(--kportal-gold);
    outline-offset: 2px;
}

/* Bump to kUML 0.54.1: a selected EDGE is highlighted by recoloring its own stroke/fill rather
   than an outline box -- an outline would span the edge's full diagonal bounding box and visually
   cover unrelated nodes sitting inside that box. No stroke-width/transition change (design-team
   ruling). */
.kportal-zoom-wrapper [data-kuml-id].kportal-canvas-selected-edge {
    outline: none;
}
.kportal-zoom-wrapper [data-kuml-id].kportal-canvas-selected-edge line,
.kportal-zoom-wrapper [data-kuml-id].kportal-canvas-selected-edge path,
.kportal-zoom-wrapper [data-kuml-id].kportal-canvas-selected-edge polyline {
    stroke: var(--kportal-gold);
}
.kportal-zoom-wrapper [data-kuml-id].kportal-canvas-selected-edge polygon {
    stroke: var(--kportal-gold);
    fill: var(--kportal-gold);
}
.kportal-zoom-wrapper [data-kuml-id].kportal-canvas-selected-edge text {
    fill: var(--kportal-gold);
}

/* ---------- R-28: presence overlay (peer cursors + selection rings) ---------- */
/* A CHILD of .kportal-zoom-wrapper (see PresenceOverlay.kt's \`create\`), sharing the diagram <svg>'s
   own viewBox -- scaled/panned in lockstep with it for free via the wrapper's own CSS transform, no
   separate positioning logic needed here. \`pointer-events: none\` so it never intercepts clicks
   meant for the diagram underneath. */
.kportal-presence-overlay {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    overflow: visible;
}

/* Smooths a peer's cursor between 10 Hz position updates -- purely cosmetic, the position itself
   (this element's \`transform\` attribute) is set fresh on every PresenceOverlayHandle.repaint(). */
.kportal-presence-cursor-outer {
    transition: transform 100ms linear;
}

.kportal-presence-cursor-arrow {
    stroke: var(--kportal-surface, #ffffff);
    stroke-width: 1.5px;
    vector-effect: non-scaling-stroke;
}

.kportal-presence-flag text {
    font-size: 11px;
    fill: #ffffff;
    dominant-baseline: middle;
}

.kportal-presence-ring {
    fill: none;
    stroke-width: 2px;
    stroke-dasharray: 4 3;
    vector-effect: non-scaling-stroke;
}

/* ---------- R-27: inspector panel ---------- */

.kportal-inspector-panel {
    border: 1px solid var(--kportal-navy-hairline);
    border-radius: var(--kportal-radius);
    padding: 16px;
    margin-bottom: 16px;
    background: var(--kportal-surface);
}

.kportal-inspector-hint {
    color: var(--kportal-muted);
    font-size: 13px;
}

.kportal-inspector-field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 10px;
}

.kportal-inspector-checkbox-field {
    flex-direction: row;
    align-items: center;
    gap: 8px;
}

.kportal-inspector-section {
    margin-top: 14px;
    padding-top: 10px;
    border-top: 1px solid var(--kportal-navy-hairline);
}

.kportal-inspector-two-nodes {
    display: flex;
    gap: 6px;
    align-items: center;
    font-weight: 600;
    margin: 8px 0;
}

.kportal-inspector-feature-row {
    display: flex;
    gap: 6px;
    align-items: center;
    padding: 4px 0;
}

.kportal-inspector-feature-label {
    cursor: pointer;
    flex: 1;
}

.kportal-inspector-relation-row {
    cursor: pointer;
    padding: 4px 0;
    color: var(--kportal-navy);
    text-decoration: underline;
}

.kportal-inspector-mult-input {
    width: 48px;
    flex: none;
}

.kportal-inspector-delete-row {
    margin-top: 14px;
    padding-top: 10px;
    border-top: 1px solid var(--kportal-navy-hairline);
}

/* ---------- R-7 diagram toolbar ---------- */

/* Overlay pill in the stage's TOP-right corner. Replaces R-6's single .kportal-zoom-reset control:
   "Fit" is now one of five tools instead of a second control doing the same job in the same box.
   Top-right rather than bottom-right leaves the bottom corner free for R-9's planned report
   control. Built per diagram in EditorScreen.kt's showDiagram() (see editor/ZoomToolbar.kt), so it
   simply does not exist in the empty state. */
.kportal-zoom-toolbar {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 1;
    display: flex;
    align-items: stretch;
    gap: 2px;
    padding: 3px;
    background: var(--kportal-bg);
    border: 1px solid var(--kportal-navy-hairline-strong);
    border-radius: var(--kportal-radius);
    box-shadow: var(--kportal-shadow);
    /* The stage owns drag-to-pan; the toolbar must never become a pan surface (pointerdown/wheel/
       dblclick are additionally stopped at this element, see ZoomToolbar.kt) and must not incur the
       mobile 300ms tap delay. */
    touch-action: manipulation;
}

.kportal-zoom-tool {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 30px;
    height: 30px;
    padding: 0 6px;
    border: none;
    border-radius: 5px;
    background: transparent;
    color: var(--kportal-ink);
    font-size: 15px;
    line-height: 1;
    cursor: pointer;
}

.kportal-zoom-tool:hover:not(:disabled) {
    background: var(--kportal-surface);
}

/* Only "+"/"-" ever reach this state (at the ends of the zoom range), plus "PNG" transiently while
   an export is encoding -- see ZoomToolbarHandle.updateZoomState()/setPngBusy(). */
.kportal-zoom-tool:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

/* The two text-label controls ("SVG"/"PNG") -- smaller and heavier than the glyph controls so a
   three-letter word reads as a label rather than as a shouted glyph. */
.kportal-zoom-tool-wide {
    padding: 0 8px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
}

.kportal-zoom-toolbar-sep {
    width: 1px;
    align-self: stretch;
    margin: 3px 2px;
    background: var(--kportal-navy-hairline-strong);
}

/* Five controls must still fit inside a narrow stage without clipping the diagram behind them. */
@media (max-width: 520px) {
    .kportal-zoom-toolbar {
        top: 8px;
        right: 8px;
        gap: 0;
    }

    .kportal-zoom-tool {
        min-width: 26px;
        height: 26px;
        padding: 0 4px;
    }
}

.kportal-stage-skeleton {
    width: 100%;
    height: 100%;
    min-height: 372px;
    background: repeating-linear-gradient(
        90deg,
        var(--kportal-navy-hairline) 0,
        var(--kportal-navy-hairline) 1px,
        transparent 1px,
        transparent 2px
    );
    opacity: 0.5;
    border-radius: var(--kportal-radius);
}

.kportal-empty-diagram {
    text-align: center;
    color: var(--kportal-muted);
    max-width: 340px;
}

.kportal-prompt-panel {
    background: var(--kportal-surface);
    border: 1px solid var(--kportal-navy-hairline);
    border-radius: var(--kportal-radius);
    padding: 24px;
    min-width: 320px;
}

/* ---------- R-8: attach-a-context-file control ---------- */

.kportal-attach-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
    flex-wrap: wrap;
}

.kportal-attach-hint {
    font-size: 13px;
    color: var(--kportal-muted);
}

.kportal-attach-chip-row {
    margin-top: 8px;
}

.kportal-chip-remove {
    background: none;
    border: none;
    color: var(--kportal-muted);
    cursor: pointer;
    font-size: 15px;
    line-height: 1;
    padding: 0;
}

.kportal-chip-remove:hover {
    color: var(--kportal-danger);
}

.kportal-status-area {
    margin-top: 16px;
    min-height: 24px;
    font-size: 13px;
}

.kportal-status-success {
    color: var(--kportal-ink);
    display: flex;
    align-items: center;
    gap: 8px;
}

.kportal-status-error {
    color: var(--kportal-danger);
}

.kportal-status-neutral {
    color: var(--kportal-muted);
}

.kportal-status-detail {
    color: var(--kportal-muted);
    margin-top: 4px;
}

.kportal-dsl-toggle {
    margin-top: 24px;
    font-size: 13px;
    color: var(--kportal-muted);
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
}

.kportal-dsl-content {
    margin-top: 8px;
    background: var(--kportal-bg);
    border: 1px solid var(--kportal-navy-hairline);
    border-radius: var(--kportal-radius);
    padding: 12px;
    font-family: "SFMono-Regular", Consolas, monospace;
    font-size: 13px;
    white-space: pre-wrap;
    max-height: 240px;
    overflow-y: auto;
}

.kportal-hidden {
    display: none !important;
}

/* ---------- R-26: persistent project-file store panel ---------- */

.kportal-files-panel {
    margin-top: 24px;
    border-top: 1px solid var(--kportal-navy-hairline);
    padding-top: 12px;
}

.kportal-files-toggle {
    font-size: 13px;
    color: var(--kportal-muted);
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
}

.kportal-files-body {
    margin-top: 8px;
}

.kportal-file-row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 0;
    border-bottom: 1px solid var(--kportal-navy-hairline);
    flex-wrap: wrap;
}

.kportal-file-thumb {
    width: 32px;
    height: 32px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid var(--kportal-navy-hairline);
}

.kportal-file-name {
    font-weight: 500;
}

.kportal-file-size {
    font-size: 12px;
    color: var(--kportal-muted);
}

.kportal-file-desc {
    font-size: 13px;
    color: var(--kportal-muted);
    flex: 1 1 auto;
}

.kportal-files-desc-input {
    max-width: 260px;
}

.kportal-files-index {
    margin-top: 8px;
}

.kportal-files-index-pre {
    background: var(--kportal-bg);
    border: 1px solid var(--kportal-navy-hairline);
    border-radius: var(--kportal-radius);
    padding: 12px;
    font-family: "SFMono-Regular", Consolas, monospace;
    font-size: 13px;
    white-space: pre-wrap;
    max-height: 240px;
    overflow-y: auto;
}

/* ---------- Legal pages (Impressum / Datenschutz) ---------- */

.kportal-prose {
    padding-top: 32px;
    max-width: 760px;
}

.kportal-legal-back {
    font-size: 13px !important;
    font-weight: 400 !important;
    cursor: pointer;
    border: none !important;
    background: none !important;
    color: var(--kportal-muted) !important;
    padding: 0 !important;
    margin-bottom: 24px;
}

.kportal-prose h1 {
    font-size: 28px;
    margin-bottom: 24px;
}

.kportal-prose h2 {
    font-size: 17px;
    margin-top: 32px;
    margin-bottom: 8px;
}

.kportal-prose > div {
    margin-bottom: 4px;
    line-height: 1.6;
}

.kportal-prose ul {
    margin: 4px 0 8px;
    padding-left: 20px;
}

.kportal-prose li {
    margin-bottom: 4px;
}

/* ---------- Avatars (R-16) ---------- */

/* Base shape shared by every size -- position: relative so the fallback initials and the <img>
   overlap exactly; the fallback is always in the DOM (see components/Avatar.kt), the <img> is
   simply hidden (.kportal-hidden) on load error rather than removed. */
.kportal-avatar {
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    background: var(--kportal-surface);
    cursor: pointer;
}

.kportal-avatar-fallback {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    color: var(--kportal-muted);
    background: var(--kportal-surface);
    user-select: none;
}

.kportal-avatar-img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.kportal-avatar-sm {
    width: 24px;
    height: 24px;
    font-size: 10px;
}

.kportal-avatar-md {
    width: 32px;
    height: 32px;
    font-size: 12px;
}

.kportal-avatar-lg {
    width: 96px;
    height: 96px;
    font-size: 28px;
}

.kportal-header-avatar {
    margin-left: 4px;
}

.kportal-profile-avatar-row {
    margin-bottom: 16px;
}

/* Overlapping presence avatars in the editor sub-header (R-16, live collaboration). */
.kportal-collab-avatars {
    display: flex;
    align-items: center;
    gap: 2px;
    margin-left: auto;
}

.kportal-collab-avatars .kportal-avatar-sm {
    border: 2px solid var(--kportal-bg);
    margin-left: -6px;
}

.kportal-collab-avatars .kportal-avatar-sm:first-child {
    margin-left: 0;
}

.kportal-avatar-overflow {
    font-size: 12px;
    color: var(--kportal-muted);
    margin-left: 4px;
}

/* ---------- R-9: report-as-incorrect + comment thread ---------- */

.kportal-report-row {
    margin-top: 12px;
}

/* R-25: replaces the melde-Button when no generation exists yet -- same muted, non-alarming
 * treatment as .kportal-attach-hint/.kportal-consent-hint, deliberately no warning color. */
.kportal-report-hint {
    font-size: 13px;
    color: var(--kportal-muted);
}

.kportal-report-form-row {
    margin-top: 8px;
}

.kportal-report-thread {
    margin-top: 16px;
}

.kportal-report-comment {
    padding: 10px 0;
    border-top: 1px solid var(--kportal-navy-hairline);
}

.kportal-report-comment-body {
    margin-top: 4px;
    white-space: pre-wrap;
}

/* Visually distinguishes server-verified admin replies (authorRole == "admin") from regular
 * member replies -- deliberately NOT relying on the "kUML-Team" label text alone, because a
 * member could otherwise register with that exact display name and produce a visually identical
 * row. The left accent bar + tint are driven purely by this class, which the frontend only ever
 * applies based on the server-derived authorRole. */
.kportal-report-comment-admin {
    border-left: 3px solid var(--kportal-gold);
    padding-left: 10px;
    background: rgba(196, 154, 46, 0.08);
}

/* R-18: a real element (rendered by EditorScreen.kt's renderThread) replaces the pre-R-18
 * \`::after { content: "Verifiziert" }\` -- generated pseudo-element content cannot follow a
 * language switch, and is invisible to many screen readers, so this is also an accessibility
 * improvement, not just an i18n fix. */
.kportal-report-verified {
    margin-left: 8px;
    padding: 1px 6px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: var(--kportal-navy);
    background: var(--kportal-gold);
}

@media (prefers-color-scheme: dark) {
    .kportal-report-verified {
        color: var(--kportal-ink);
    }
}

/* ---------- R-11: consent toggles ---------- */

.kportal-consent-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-top: 16px;
}

.kportal-consent-text {
    flex: 1;
}

.kportal-consent-hint {
    font-size: 13px;
    color: var(--kportal-muted);
    margin-top: 2px;
}

/* ---------- R-15: Aktivitätsdiagramm ---------- */

.kportal-activity {
    margin: 40px 0 24px;
}

.kportal-activity-head {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 12px;
}

.kportal-activity-title {
    font-size: 18px;
    font-weight: 600;
}

.kportal-activity-summary {
    font-size: 13px;
    color: var(--kportal-muted);
}

.kportal-activity-months {
    display: flex;
    gap: 3px;
    margin-bottom: 4px;
    padding-left: 2px;
}

.kportal-activity-month-label {
    width: 13px;
    flex: 0 0 auto;
    font-size: 11px;
    color: var(--kportal-muted);
    overflow: visible;
    white-space: nowrap;
}

.kportal-activity-grid {
    display: flex;
    gap: 3px;
    overflow-x: auto;
    padding-bottom: 4px;
}

.kportal-activity-week {
    display: flex;
    flex-direction: column;
    gap: 3px;
    flex: 0 0 auto;
}

.kportal-activity-day {
    width: 11px;
    height: 11px;
    border-radius: 2px;
    background: var(--kportal-navy-hairline);
}

.kportal-activity-day.level-1 { background: #c3ddfd; }
.kportal-activity-day.level-2 { background: #84b6f4; }
.kportal-activity-day.level-3 { background: #4c6ef5; }
.kportal-activity-day.level-4 { background: #2f4bcb; }

@media (prefers-color-scheme: dark) {
    .kportal-activity-day.level-1 { background: #1c3a66; }
    .kportal-activity-day.level-2 { background: #26508c; }
    .kportal-activity-day.level-3 { background: #3868c4; }
    .kportal-activity-day.level-4 { background: #5a8bf0; }
}

.kportal-activity-legend {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 8px;
    font-size: 11px;
    color: var(--kportal-muted);
}

.kportal-activity-legend-label {
    font-size: 11px;
    color: var(--kportal-muted);
}

.kportal-activity-legend-swatch {
    width: 11px;
    height: 11px;
    border-radius: 2px;
    background: var(--kportal-navy-hairline);
}

.kportal-activity-legend-swatch.level-1 { background: #c3ddfd; }
.kportal-activity-legend-swatch.level-2 { background: #84b6f4; }
.kportal-activity-legend-swatch.level-3 { background: #4c6ef5; }
.kportal-activity-legend-swatch.level-4 { background: #2f4bcb; }

@media (prefers-color-scheme: dark) {
    .kportal-activity-legend-swatch.level-1 { background: #1c3a66; }
    .kportal-activity-legend-swatch.level-2 { background: #26508c; }
    .kportal-activity-legend-swatch.level-3 { background: #3868c4; }
    .kportal-activity-legend-swatch.level-4 { background: #5a8bf0; }
}

@media (max-width: 600px) {
    .kportal-activity-grid {
        overflow-x: auto;
    }
}

/* ---------- R-21: Link-Sharing ---------- */

.kportal-share-dialog {
    position: absolute;
    z-index: 10;
    top: 100%;
    left: 0;
    margin-top: 8px;
    background: var(--kportal-bg);
    border: 1px solid var(--kportal-navy-hairline);
    border-radius: var(--kportal-radius);
    box-shadow: var(--kportal-shadow);
    padding: 16px;
    width: 320px;
    font-size: 13px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.kportal-share-links {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.kportal-share-link-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 6px 0;
    border-bottom: 1px solid var(--kportal-navy-hairline);
    position: relative;
}

.kportal-share-link-meta {
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 12px;
    color: var(--kportal-muted);
}

.kportal-share-link-actions {
    display: flex;
    align-items: center;
    gap: 4px;
}

.kportal-share-badge {
    display: inline-block;
    font-size: 11px;
    color: var(--kportal-ink);
    background: var(--kportal-surface);
    border: 1px solid var(--kportal-navy-hairline);
    border-radius: 999px;
    padding: 1px 8px;
    width: fit-content;
}

.kportal-share-url {
    width: 100%;
    font-size: 12px;
}

/* ---------- R-21: Public share viewer (/s/:token) ---------- */

.kportal-public-share {
    max-width: 960px;
    margin: 32px auto;
    padding: 0 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.kportal-public-share-stage {
    background: var(--kportal-surface);
    border: 1px solid var(--kportal-navy-hairline);
    border-radius: var(--kportal-radius);
    padding: 16px;
    display: flex;
    justify-content: center;
    overflow: auto;
}

.kportal-public-share-stage img {
    max-width: 100%;
    height: auto;
}

.kportal-public-share-actions {
    display: flex;
    justify-content: center;
}

.kportal-public-share-message {
    text-align: center;
    padding: 64px 24px;
    color: var(--kportal-muted);
}

.kportal-public-share-locked {
    max-width: 320px;
    margin: 64px auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
    text-align: center;
}

.kportal-public-share-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-top: 32px;
    padding-top: 16px;
    border-top: 1px solid var(--kportal-navy-hairline);
    flex-wrap: wrap;
}

/* ---------- R-5: Social Login ---------- */

.kportal-auth-divider {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 20px 0;
    color: var(--kportal-muted);
    font-size: 13px;
}

.kportal-auth-divider::before,
.kportal-auth-divider::after {
    content: "";
    flex: 1;
    border-top: 1px solid var(--kportal-navy-hairline);
}

.kportal-auth-divider-label {
    white-space: nowrap;
}

.kportal-auth-oauth-buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.kportal-btn-oauth {
    width: 100%;
    text-align: center;
    border: 1px solid var(--kportal-navy-hairline);
    background: var(--kportal-surface);
    color: var(--kportal-ink);
}

.kportal-btn-oauth:hover {
    border-color: var(--kportal-navy-hairline-strong);
}

.kportal-profile-oauth-rows {
    margin-top: 12px;
}

.kportal-profile-oauth-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 0;
    border-top: 1px solid var(--kportal-navy-hairline);
}

.kportal-profile-oauth-info {
    flex: 1;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
